import { Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-payment-status-page',
  templateUrl: './payment-status-page.component.html',
  styleUrls: ['./payment-status-page.component.css']
})
export class PaymentStatusPageComponent implements OnInit {

  paramData:any = {};
  orderData = null;
  isOpenPrint = false
  pdfUrl : any
  invoiceData = null;

  constructor(public shared: SharedService, private route: ActivatedRoute, private apiService: ApiServiceService,private http: HttpClient) {
    this.shared.isWhiteMenu = true;
    this.shared.isLoader = true;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
        this.paramData = params;
        if(params["OrderRef"]) {
          this.fetchOrderStatus();
        }
    });
  }

  async fetchOrderStatus() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CHECK_STATUS, { ref: this.paramData["OrderRef"]});
    if(res && res.data && res.data.data && res.data.data.order) {
      console.log("res.data.data",res.data.data)
      this.orderData = res.data.data.order;

      if(this.orderData.status.text == 'Paid') {
        if(res.data.invoiceData) {
          this.invoiceData = res.data.invoiceData;
        }

      // this.pdfUrl = res.data.urlData.url
      //   window.open(res.data.urlData.url);
      //   this.shared.isLoader = false;
      // //   })
      }
      this.shared.isLoader = false;
    } else {
      this.shared.isLoader = false;
    }
    // console.log(res);
  }

  async printInvoice() {
    this.shared.isLoader = true;
    this.apiService.isBlob = true;
    await this.apiService.POST_apiRequest(configuration.ENDPOINT.COMMON_PDF, { type: "invoice", id: this.invoiceData.id })
    this.shared.isLoader = false;
  }

  onPrint(){
    this.http.get(this.pdfUrl, { responseType: 'blob' }).subscribe((response: any) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = 'invoice.pdf';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  }

}
